import { usePageMeta } from "@/lib/usePageMeta";
import { EmptyState, ArrowLink } from "@/components/site/Content";
import { useCopy } from "@/lib/copy";

export default function NotFound() {
  const t = useCopy();
  usePageMeta("Page not found");
  return (
    <div className="container-x py-20">
      <EmptyState title={t("notfound.main.title")} message={t("notfound.main.text")} testId="not-found" action={<ArrowLink to="/" testId="not-found-home-link">{t("notfound.main.link")}</ArrowLink>} />
    </div>
  );
}
